import Request from '../../lib/exchange/request'
import RequestTypes from '../../lib/exchange-api/request-types'

class AuthRequest extends Request {
    constructor(login, auth_token, generate_auth_token) {
        super({
            req: RequestTypes.AUTH,
            req_id: 0,
            login: login,
            auth_token: auth_token, 
            generate_auth_token: generate_auth_token
        });
    }
}

export default AuthRequest;